<template>
<div>
    <component :is="componentType" v-model="localValue" noCloseOnBackdrop noCloseOnScape hideClose>
        <paginated-table :fields="columns" :items="data">
            <template #head()="data">
                <span v-if="data.column.includes('num')">
                    <base-icon :src="getConsultationIcon(data.column)" :color="BLUE_COLOUR"></base-icon>
                </span>
                <span v-else-if="data.label" v-html="data.label"></span>
            </template>
            <template #cell(action)="data">
                <base-button @click="$emit('servicesPackageSelected', data.item.id)">{{ $t('hire') }}</base-button>
            </template>
        </paginated-table>
        <div class="mt-5">
            <b-icon-info-circle></b-icon-info-circle> {{ $t('minorsAndSpousesIncluded') }}
        </div>
    </component>
</div>
</template>
  
<script>
import PaginatedTable from '@/components/base/PaginatedTable'
import { getCurrencyByDomain } from '@/constants/currencies'
import BaseModal from '@/components/base/BaseModal'
import { INPLACE, WRITTEN, CHAT, VIDEO, IMMEDIATE_VIDEO, AT_HOME, SECOND_OPINION, getConsultationIconById } from '@/constants/consultationTypes'
import { BLUE_COLOUR } from '@/constants/colours'
import BaseButton from '@/components/base/buttons/BaseButton.vue'

const BASE_MODAL_COMPONENT = 'base-modal'
const BASE_CARD_COMPONENT = 'base-card'

export default {
    components: {
        PaginatedTable,
        BaseModal,
        BaseButton
    },
    props: {
        value: Boolean,
        modal: Boolean,
        data: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            BLUE_COLOUR,
            dataPropsMap: {
                numInplace: INPLACE,
                numVideo: VIDEO,
                numInmediate: IMMEDIATE_VIDEO,
                numWebmail: WRITTEN,
                numChat: CHAT,
                numOpinion: SECOND_OPINION,
                numAway: AT_HOME
            },
            columns: [
                {
                    key: 'description',
                    label: this.$i18n.t('package')
                },
                {
                    key: 'price',
                    label: this.$i18n.t('price'),
                    formatter: (value, key, item) => {
                        return `${value} ${getCurrencyByDomain()}`
                    }
                },
                {
                    key: 'duration',
                    label: this.$i18n.t('duration'),
                    formatter: (value, key, item) => {
                        return value ? `${value} ${this.$t('days')}` : '∞'
                    }
                },
                {
                    key: 'numInplace',
                    formatter: (value, key, item) => {
                        return this.getCellValue(value, item)
                    }
                },
                {
                    key: 'numVideo',
                    formatter: (value, key, item) => {
                        return this.getCellValue(value, item)
                    }
                },
                {
                    key: 'numInmediate',
                    formatter: (value, key, item) => {
                        return this.getCellValue(value, item)
                    }
                },
                {
                    key: 'numWebmail',
                    formatter: (value, key, item) => {
                        return this.getCellValue(value, item)
                    }
                },
                {
                    key: 'numChat',
                    formatter: (value, key, item) => {
                        return this.getCellValue(value, item)
                    }
                },
                {
                    key: 'numAway',
                    formatter: (value, key, item) => {
                        return this.getCellValue(value, item)
                    }
                },
                {
                    key: 'numOpinion',
                    formatter: (value, key, item) => {
                        return this.getCellValue(value, item)
                    }
                },
                {
                    key: 'action',
                    label: ''
                }
            ]
        }
    },
    computed: {
        localValue: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value)
            }
        },
        componentType () {
            return this.modal ? BASE_MODAL_COMPONENT : BASE_CARD_COMPONENT
        }
    },
    methods: {
        getConsultationIcon (column) {
            return getConsultationIconById(this.dataPropsMap[column])
        },
        getCellValue (value, item) {
            let result = ''
            if (!value) {
                result += '-'
            } else {
                result += value === -1 ? '∞' : value
            }
            if (item.numInplaceMonthly) result += `/${this.$t('month')}`
            return result
        }
    }
}
</script>

<style lang="scss" scoped>
.glyphicon-info-sign {
    color: $gray-600;
}

.note-sm {
    font-size: 11px;
    color: $gray-600;
}

/deep/.table-btn {
    font-size: 12px;
}

/deep/.icon-label-cnt {
        width: 25px;
        @include media(mobile, tablets) {
            text-align: center;
        }
}

/deep/tr {
    @include media(tablets) {
    line-height: 1.2;
    }

    @include media(tablets) {
    line-height: 1.2;
    }

    td {
    padding: 1rem 1.5rem;
    text-align: center;
    }
}

/deep/th {
    padding:1rem 1.75rem;
    text-align: center;
}

@include media(mobile, tablets) {
    .packs-table {
        display: block;
        overflow-x: auto;
        white-space: nowrap;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/shared/ServicesPackagesTable.vue